var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31849 12.6039C3.31849 8.1107 6.96092 4.46826 11.4541 4.46826V4.46826C15.9473 4.46826 19.5897 8.1107 19.5897 12.6039V20.6391C19.5897 20.832 19.6455 21.0208 19.7504 21.1827L21.0789 23.2341C21.5098 23.8994 21.0322 24.7777 20.2396 24.7777H11.4541H2.18472C1.32865 24.7777 0.868354 23.7721 1.42785 23.1241L3.07536 21.2162C3.23219 21.0345 3.31849 20.8026 3.31849 20.5626V12.6039Z",
    stroke: "#252629",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1471 24.7773C15.1471 27.1093 13.308 28.9997 11.0394 28.9997C8.77074 28.9997 6.93164 27.1093 6.93164 24.7773",
    stroke: "#252629",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1031 14.9499C24.9829 14.9499 28.1281 11.8047 28.1281 7.92491C28.1281 4.0451 24.9829 0.899902 21.1031 0.899902C17.2233 0.899902 14.0781 4.0451 14.0781 7.92491C14.0781 11.8047 17.2233 14.9499 21.1031 14.9499Z",
    fill: "#FFC600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1174 8.02539C25.1174 8.02539 23.311 8.02539 21.1032 8.02539C18.8953 8.02539 17.0889 8.02539 17.0889 8.02539C17.0889 8.02539 18.8953 8.02539 21.1032 8.02539C23.311 8.02539 25.1174 8.02539 25.1174 8.02539Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2031 11.9392C21.2031 11.9392 21.2031 10.1328 21.2031 7.92493C21.2031 5.71707 21.2031 3.91064 21.2031 3.91064C21.2031 3.91064 21.2031 5.71707 21.2031 7.92493C21.2031 10.1328 21.2031 11.9392 21.2031 11.9392Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertAdd);
export default __webpack_public_path__ + "static/media/alert-add.05fd450b5c4c2b421c27b440b1a78025.svg";
export { ForwardRef as ReactComponent };